if (typeof CollectionStoreHeader !== 'function') {
  class CollectionStoreHeader extends HTMLElement {
    connectedCallback() {
      this.titleEl = this.querySelector('[data-js-collection-store-title]');
      this.infoEl = this.querySelector('[data-js-collection-store-info]');
      this.mediaEl = this.querySelector('[data-js-collection-store-media]');
      this.bannerEl = this.querySelector('[data-js-collection-store-banner]');
      this.defaultTitle = this.dataset.defaultTitle || (this.titleEl ? this.titleEl.textContent.trim() : '');
      this.applyHandles = (this.dataset.applyHandles || 'all,delivery')
        .split(',')
        .map((handle) => handle.trim())
        .filter(Boolean);
      this.collectionHandle = this.dataset.collectionHandle || '';
      this.stores = this.#parseStores();

      this.#render();

      document.addEventListener('storechanged', () => this.#render());
      window.addEventListener('storage', (event) => {
        if (event.key === 'selected-store' || event.key === 'fulfillment-mode') {
          this.#render();
        }
      });
    }

    #parseStores() {
      const script = this.querySelector('[data-js-collection-store-data]');
      if (!script) return {};
      try {
        return JSON.parse(script.textContent);
      } catch (error) {
        return {};
      }
    }

    #shouldApply() {
      if (!this.applyHandles.length) return true;
      return this.applyHandles.includes(this.collectionHandle);
    }

    #render() {
      if (!this.titleEl || !this.#shouldApply()) return;

      const inventory = window.LetsDishLocationInventory;
      const fulfillmentMode = inventory && inventory.getMode
        ? inventory.getMode()
        : (localStorage.getItem('fulfillment-mode') || 'pickup');
      const selectedStore = localStorage.getItem('selected-store') || '';
      const isDelivery =
        fulfillmentMode === 'delivery'
        || this.collectionHandle === 'delivery'
        || (inventory && inventory.isDeliveryCollectionPath && inventory.isDeliveryCollectionPath());

      if (isDelivery && this.stores.delivery) {
        this.titleEl.textContent = this.stores.delivery.title || 'Delivery';
        this.#setInfo(this.stores.delivery.html || '');
        this.#setImage('');
        if (this.bannerEl) this.bannerEl.hidden = true;
        return;
      }

      const store = selectedStore ? this.stores[selectedStore] : null;
      if (store) {
        this.titleEl.textContent = store.title || this.defaultTitle;
        this.#setInfo(store.html || '');
        this.#setImage(store.image || '', store.title || '');
        if (this.bannerEl) this.bannerEl.hidden = true;
        return;
      }

      this.titleEl.textContent = this.defaultTitle;
      this.#setInfo('');
      this.#setImage('');
      if (this.bannerEl) this.bannerEl.hidden = true;
    }

    #setImage(src, alt) {
      if (!this.mediaEl) return;
      if (!src) {
        this.mediaEl.hidden = true;
        this.mediaEl.innerHTML = '';
        return;
      }
      const img = document.createElement('img');
      img.src = src;
      img.alt = alt || '';
      img.loading = 'lazy';
      img.addEventListener('error', () => {
        this.mediaEl.hidden = true;
        this.mediaEl.innerHTML = '';
      });
      this.mediaEl.innerHTML = '';
      this.mediaEl.appendChild(img);
      this.mediaEl.hidden = false;
    }

    #setInfo(html) {
      if (!this.infoEl) return;
      if (html) {
        this.infoEl.innerHTML = html;
        this.infoEl.hidden = false;
      } else {
        this.infoEl.innerHTML = '';
        this.infoEl.hidden = true;
      }
    }
  }

  customElements.define('collection-store-header', CollectionStoreHeader);
}
